import StarRating from "@/app/components/elements/StarRating";

interface ReviewHeaderProps {
  title: string;
  rating: number;
  reviewCount: number;
  commentCount: number;
}

const ReviewHeader = ({
  title,
  rating,
  reviewCount,
}: ReviewHeaderProps) => {
  return (
    <div className="space-y-3">
      <h1 className="text-2xl font-bold">{title}</h1>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-lg font-bold text-gray-900">
            {rating > 0 ? rating.toFixed(1) : '0.0'}
          </span>
          <StarRating rating={rating} size="sm" />
        </div>
        <span className="text-sm text-gray-600">
          <span className="font-semibold">{reviewCount}</span> değerlendirme
        </span>
      </div>
    </div>
  );
};

export default ReviewHeader;